import { ReactNode } from 'react'
import { Mtds } from 'prove-common'
import { Link } from 'react-router'

type PlanStatCardColor = 'success' | 'danger'

type PlanStatCardProps = {
  label: string
  value: ReactNode
  description: ReactNode
  badge?: ReactNode
  progressValue: number
  progressMax: number
  color: PlanStatCardColor
  to?: string
}

export const PlanStatCard = ({
  label,
  value,
  description,
  badge,
  progressValue,
  progressMax,
  color,
  to
}: PlanStatCardProps) => {
  const cardContent = (
    <Mtds.Grid data-gap='6'>
      <Mtds.Grid data-gap='3'>
        <Mtds.Flex
          data-align='center'
          data-justify='space-between'
          data-gap='2'
        >
          <Mtds.Muted>{label}</Mtds.Muted>
          {badge}
        </Mtds.Flex>
        <Mtds.Grid data-gap='0'>
          <Mtds.Heading as='p' data-size='xl'>
            {value}
          </Mtds.Heading>
          <Mtds.Muted>{description}</Mtds.Muted>
        </Mtds.Grid>
      </Mtds.Grid>
      <Mtds.Progress value={progressValue} max={progressMax} />
    </Mtds.Grid>
  )

  if (to) {
    return (
      <Mtds.Card
        data-color={color}
        className='bg-background-tinted hover:bg-surface-hover'
        data-clickdelegatefor={`plan-stat-link-${label}`}
      >
        <Link id={`plan-stat-link-${label}`} to={to} hidden />
        {cardContent}
      </Mtds.Card>
    )
  }

  return (
    <Mtds.Card data-color={color} className='bg-background-tinted'>
      {cardContent}
    </Mtds.Card>
  )
}
